import type { SVGProps } from 'react';
import type React from 'react';

export function EngagementPlatformIconStack(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 113 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_11_3854)">
        <g clipPath="url(#clip0_11_3854)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 5.48364 25.5415)"
            fill="white"
          />
          <path
            d="M20.4195 12.4164C20.4195 11.7533 20.9613 11.2115 21.6244 11.2115C22.2876 11.2115 22.8293 11.7533 22.8293 12.4164C22.8293 13.0796 22.2876 13.6213 21.6244 13.6213H20.4195V12.4164Z"
            fill="#E01E5A"
          />
          <path
            d="M19.8124 12.4164C19.8124 13.0796 19.2706 13.6213 18.6075 13.6213C17.9443 13.6213 17.4025 13.0796 17.4025 12.4164V9.39946C17.4025 8.73629 17.9443 8.19455 18.6075 8.19455C19.2706 8.19455 19.8124 8.73629 19.8124 9.39946V12.4164Z"
            fill="#E01E5A"
          />
          <path
            d="M18.6075 17.2547C19.2706 17.2547 19.8124 17.7965 19.8124 18.4596C19.8124 19.1228 19.2706 19.6646 18.6075 19.6646C17.9443 19.6646 17.4025 19.1228 17.4025 18.4596V17.2547H18.6075Z"
            fill="#36C5F0"
          />
          <path
            d="M18.6075 16.6477C17.9443 16.6477 17.4026 16.106 17.4026 15.4428C17.4026 14.7796 17.9443 14.2379 18.6075 14.2379H21.6244C22.2876 14.2379 22.8293 14.7796 22.8293 15.4428C22.8293 16.106 22.2876 16.6477 21.6244 16.6477H18.6075Z"
            fill="#36C5F0"
          />
          <path
            d="M13.7691 15.4428C13.7691 16.106 13.2274 16.6477 12.5642 16.6477C11.901 16.6477 11.3593 16.106 11.3593 15.4428C11.3593 14.7796 11.901 14.2379 12.5642 14.2379H13.7691V15.4428Z"
            fill="#2EB67D"
          />
          <path
            d="M14.3762 15.4427C14.3762 14.7795 14.918 14.2378 15.5812 14.2378C16.2443 14.2378 16.7861 14.7795 16.7861 15.4427V18.4596C16.7861 19.1228 16.2443 19.6646 15.5812 19.6646C14.918 19.6646 14.3762 19.1228 14.3762 18.4596V15.4427Z"
            fill="#2EB67D"
          />
          <path
            d="M15.5812 10.6042C14.918 10.6042 14.3762 10.0625 14.3762 9.39933C14.3762 8.73616 14.918 8.19442 15.5812 8.19442C16.2443 8.19442 16.7861 8.73616 16.7861 9.39933V10.6042H15.5812Z"
            fill="#ECB22E"
          />
          <path
            d="M15.5812 11.2115C16.2443 11.2115 16.7861 11.7533 16.7861 12.4164C16.7861 13.0796 16.2443 13.6213 15.5812 13.6213H12.5642C11.901 13.6213 11.3593 13.0796 11.3593 12.4164C11.3593 11.7533 11.901 11.2115 12.5642 11.2115H15.5812Z"
            fill="#ECB22E"
          />
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter1_d_11_3854)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 5.53638 25.5415)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 5.53638 24.5622)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 5.48364 24.5622)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <g filter="url(#filter2_d_11_3854)">
        <g clipPath="url(#clip1_11_3854)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 31.5995 25.5415)"
            fill="white"
          />
          <mask
            id="mask0_11_3854"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="37"
            y="8"
            width="12"
            height="12"
          >
            <ellipse
              cx="46.4548"
              cy="16.7191"
              rx="2.48984"
              ry="2.48984"
              fill="#C4C4C4"
            />
            <ellipse
              cx="39.9644"
              cy="16.7191"
              rx="2.48984"
              ry="2.48984"
              fill="#C4C4C4"
            />
            <ellipse
              cx="43.2096"
              cy="11.068"
              rx="2.48984"
              ry="2.48984"
              fill="#C4C4C4"
            />
          </mask>
          <g mask="url(#mask0_11_3854)">
            <path
              d="M43.2152 8.5166C46.701 8.5166 49.5265 11.3421 49.5265 14.8335C49.5265 18.3193 46.701 21.1448 43.2152 21.1448C39.7294 21.1448 36.8983 18.3193 36.8983 14.8335C36.8983 11.3421 39.7238 8.5166 43.2152 8.5166Z"
              fill="url(#paint0_radial_11_3854)"
            />
          </g>
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter3_d_11_3854)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 31.6542 25.5415)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 31.6542 24.5622)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 31.5995 24.5622)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <g filter="url(#filter4_d_11_3854)">
        <g clipPath="url(#clip2_11_3854)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 57.7154 25.5415)"
            fill="white"
          />
          <rect
            x="63.5904"
            y="8.1958"
            width="11.4701"
            height="11.4701"
            fill="url(#pattern0_11_3854)"
          />
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter5_d_11_3854)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 57.7701 25.5415)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 57.7701 24.5622)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 57.7154 24.5622)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <g filter="url(#filter6_d_11_3854)">
        <g clipPath="url(#clip3_11_3854)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 83.8313 25.5415)"
            fill="white"
          />
          <g clipPath="url(#clip4_11_3854)">
            <path
              d="M95.4414 8.21509C94.3109 8.21509 93.2058 8.55032 92.2658 9.17839C91.3258 9.80646 90.5932 10.6992 90.1606 11.7436C89.728 12.7881 89.6148 13.9373 89.8353 15.0461C90.0559 16.1549 90.6003 17.1734 91.3996 17.9728C92.199 18.7721 93.2175 19.3165 94.3263 19.5371C95.4351 19.7576 96.5843 19.6444 97.6288 19.2118C98.6732 18.7792 99.5659 18.0466 100.194 17.1066C100.822 16.1666 101.157 15.0615 101.157 13.931C101.157 12.4152 100.554 10.9617 99.4825 9.88991C98.4107 8.8181 96.9572 8.2157 95.4414 8.21509ZM95.4414 18.1367C94.6096 18.1367 93.7965 17.89 93.1049 17.4279C92.4132 16.9658 91.8742 16.3089 91.5559 15.5404C91.2375 14.772 91.1543 13.9263 91.3165 13.1105C91.4788 12.2947 91.8794 11.5453 92.4675 10.9571C93.0557 10.369 93.8051 9.9684 94.6209 9.80612C95.4367 9.64384 96.2824 9.72713 97.0509 10.0454C97.8193 10.3638 98.4762 10.9028 98.9383 11.5944C99.4004 12.2861 99.6471 13.0992 99.6471 13.931C99.6485 14.4837 99.5406 15.0312 99.3297 15.5421C99.1189 16.0529 98.8091 16.5171 98.4183 16.9079C98.0275 17.2987 97.5633 17.6084 97.0525 17.8193C96.5416 18.0302 95.9941 18.138 95.4414 18.1367Z"
              fill="#F12E45"
            />
            <path
              d="M96.859 13.7028C97.5157 13.7028 98.048 13.1705 98.048 12.5138C98.048 11.8571 97.5157 11.3247 96.859 11.3247C96.2023 11.3247 95.6699 11.8571 95.6699 12.5138C95.6699 13.1705 96.2023 13.7028 96.859 13.7028Z"
              fill="#F12E45"
            />
            <path
              d="M96.859 16.5375C97.5157 16.5375 98.048 16.0052 98.048 15.3485C98.048 14.6918 97.5157 14.1594 96.859 14.1594C96.2023 14.1594 95.6699 14.6918 95.6699 15.3485C95.6699 16.0052 96.2023 16.5375 96.859 16.5375Z"
              fill="#F12E45"
            />
            <path
              d="M94.0236 16.5375C94.6803 16.5375 95.2127 16.0052 95.2127 15.3485C95.2127 14.6918 94.6803 14.1594 94.0236 14.1594C93.3669 14.1594 92.8346 14.6918 92.8346 15.3485C92.8346 16.0052 93.3669 16.5375 94.0236 16.5375Z"
              fill="#F12E45"
            />
            <path
              d="M94.0236 13.7028C94.6803 13.7028 95.2127 13.1705 95.2127 12.5138C95.2127 11.8571 94.6803 11.3247 94.0236 11.3247C93.3669 11.3247 92.8346 11.8571 92.8346 12.5138C92.8346 13.1705 93.3669 13.7028 94.0236 13.7028Z"
              fill="#F12E45"
            />
          </g>
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter7_d_11_3854)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 83.886 25.5415)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 83.886 24.5622)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 83.8313 24.5622)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_11_3854"
          x="0.684847"
          y="0.176352"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3854"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3854"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_11_3854"
          x="-7.67334"
          y="-9.71135"
          width="49.9237"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3854"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3854"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3854"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_11_3854"
          x="26.8008"
          y="0.176352"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3854"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3854"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_11_3854"
          x="18.4445"
          y="-9.71135"
          width="49.9237"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3854"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3854"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3854"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_11_3854"
          x="52.9166"
          y="0.176352"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3854"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3854"
            result="shape"
          />
        </filter>
        <pattern
          id="pattern0_11_3854"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_11_3854" transform="scale(0.000708215)" />
        </pattern>
        <filter
          id="filter5_d_11_3854"
          x="44.5603"
          y="-9.71135"
          width="49.9237"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3854"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3854"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3854"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_11_3854"
          x="79.0325"
          y="0.176352"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3854"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3854"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_11_3854"
          x="70.6762"
          y="-9.71135"
          width="49.9237"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3854"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3854"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3854"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_11_3854"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.2133 14.8296) rotate(-90) scale(6.31421 6.31421)"
        >
          <stop stopColor="#FFB900" />
          <stop offset="0.6" stopColor="#F95D8F" />
          <stop offset="0.9991" stopColor="#F95353" />
        </radialGradient>
        <clipPath id="clip0_11_3854">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 5.48364 25.5415)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_11_3854">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 31.5995 25.5415)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip2_11_3854">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 57.7154 25.5415)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip3_11_3854">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 83.8313 25.5415)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip4_11_3854">
          <rect
            width="11.4701"
            height="11.4701"
            fill="white"
            transform="translate(89.7063 8.1958)"
          />
        </clipPath>
        <image
          id="image0_11_3854"
          width="1412"
          height="1412"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}
